

$(document).ready(function () {
  //track if search is open then show dark overlay
  const trackSearchOpen = () => {
    const targetNode = document.getElementsByClassName("snize-ac-results")[0];

    // Return early if element doesn't exist
    if (!targetNode) return;

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      if (targetNode && targetNode.checkVisibility()) {
        $(".site-nav .site-dark-overlay").show();
      } else {
        $(".site-nav .site-dark-overlay").hide();
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  };

  // check if element exist
  const elementExist = (elementToCheck, executeIfFound) => {
    const targetNode = document.querySelector("body");

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      if ($(elementToCheck).length > 0) {
        executeIfFound();
        observer.disconnect();
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  };

  //check if search exist
  elementExist(".snize-ac-results", () => {
    trackSearchOpen();
  });

  //promos discount
  let start = { day: 21, month: 7, year: 2024, time: "02:00 PM" }; // Start date and time in HKT
  let end = { day: 21, month: 8, year: 2024, time: "05:00 PM" }; // End date and time in HKT
  let iconClassName = "promo-10";
  let result = isWithinDateTimeRangeInHKT(start, end);
  if (result) {
    $(`.${iconClassName}`).show();
  }

  //popup
  // var popupClassName = 'anniv'
  // var isshow = localStorage.getItem(popupClassName);
  // var dateNow = getAbsoluteHKTime().date

  // start = { day: 21, month: 8, year: 2024, time: "12:00 PM" }; // Start date and time in HKT
  // end = { day: 21, month: 8, year: 2024, time: "05:00 PM" };   // End date and time in HKT
  // var isshow = localStorage.getItem(popupClassName);
  // if ((isshow== null || isshow != dateNow) && isWithinDateTimeRangeInHKT(start,end)) {
  //     localStorage.setItem(popupClassName, dateNow);
  //     // Show popup here
  //     $(`.${popupClassName}.event-popup`).show();
  // }

  // home page banner
  start = { day: 21, month: 8, year: 2024, time: "08:07 AM" }; // Start date and time in HKT
  end = { day: 21, month: 8, year: 2024, time: "05:00 PM" }; // End date and time in HKT
  let desktop =
    "https://cdn.shopify.com/s/files/1/0177/8784/6756/files/RAKxOpen_Web_Store_Banner_ads_copy.jpg?v=1721716882";
  let mobile =
    "https://cdn.shopify.com/s/files/1/0177/8784/6756/files/RAKxOpen_Web_Banner_Ads_2_Mobile.jpg?v=1721730461";
  let link =
    "https://store.rakwireless.com/collections/iot-education-kits-by-rakwireless-and-open?utm_source=store_banner&utm_medium=organic&utm_campaign=rakxopen_launch";
  let pagination = "light-pagination";
  const launch = isWithinDateTimeRangeInHKT(start, end);
  if (launch) {
    banner_list_main.unshift({
      img: {
        desktop: desktop,
        mobile: mobile,
      },
      link: link,
      pagination: pagination,
    });
  }

  const header = $("#site-navigation")[0];

  if (header) {
    const updateHeaderOffset = () => {
      document.documentElement.style.setProperty(
        "--header-offset",
        `${header.offsetHeight + 10}px`,
      );
    };

    // Initial calculation
    updateHeaderOffset();

    // Observe header size changes (announcement bar, menus, etc.)
    const resizeObserver = new ResizeObserver(updateHeaderOffset);
    resizeObserver.observe(header);

    // Optional: still update on window resize
    window.addEventListener("resize", updateHeaderOffset);
  }
});

// utm tagging start
(function () {
  const CONFIG = {
    utmSource: "rak_store",
    utmCampaign: "crossdomain",

    crossPropertyDomains: [
      "rakwireless.com",
      "www.rakwireless.com",
      "docs.rakwireless.com",
      "news.rakwireless.com",
      "store.rakwireless.com",
      "learn.rakwireless.com",
    ],

    scopeSelectors: [".product-information", "footer"],

    processedAttribute: "data-utm-processed",
    debug: false,

    mediumRules: [
      {
        medium: "product",
        selectors: [".product-card a"],
      },
      {
        medium: "cta",
        selectors: [
          ".cta a",
          ".cta-button",
          ".btn-primary",
          "a.btn",
          "a.button",
        ],
      },
      {
        medium: "banner",
        selectors: [".banner a", ".hero a"],
      },
      {
        medium: "content",
        selectors: [".content a", ".article-content a"],
      },
      {
        medium: "footer",
        selectors: ["footer a"],
      },
    ],

    fallbackMedium: "content",
    maxLength: 100,
  };

  function normalizeHost(hostname) {
    return (hostname || "").toLowerCase().replace(/^www\./, "");
  }

  function isSpecialLink(href) {
    if (!href) return true;

    const value = href.trim().toLowerCase();

    return (
      value.startsWith("#") ||
      value.startsWith("mailto:") ||
      value.startsWith("tel:") ||
      value.startsWith("javascript:")
    );
  }

  function isCrossDomain(hostname) {
    return CONFIG.crossPropertyDomains.some(function (domain) {
      return normalizeHost(domain) === normalizeHost(hostname);
    });
  }

  function hasUTM(url) {
    return Array.from(url.searchParams.keys()).some(function (key) {
      return key.toLowerCase().startsWith("utm_");
    });
  }

  function getUtmContent() {
    const h1 = document.querySelector("h1");

    let value;

    if (h1 && h1.textContent.trim()) {
      value = h1.textContent;
    } else {
      // fallback to last URL segment
      let path = window.location.pathname || "";

      path = path.replace(/^\/+|\/+$/g, "");

      const segments = path.split("/").filter(Boolean);
      value = segments.length ? segments[segments.length - 1] : "home";
    }

    try {
      value = decodeURIComponent(value);
    } catch (e) {}

    value = value.trim().replace(/\s+/g, "_").toLowerCase();

    return value.slice(0, CONFIG.maxLength);
  }

  function getUtmTerm(link) {
    const value =
      (link.textContent && link.textContent.trim()) ||
      link.getAttribute("aria-label") ||
      link.getAttribute("title") ||
      (link.querySelector("img") && link.querySelector("img").alt) ||
      "link";

    return value.replace(/\s+/g, "_").slice(0, CONFIG.maxLength);
  }

  function detectMedium(link) {
    for (const rule of CONFIG.mediumRules) {
      for (const selector of rule.selectors) {
        try {
          if (link.matches(selector) || link.closest(selector)) {
            return rule.medium;
          }
        } catch (error) {}
      }
    }

    return CONFIG.fallbackMedium;
  }

  function isWithinScope(link) {
    return CONFIG.scopeSelectors.some(function (selector) {
      try {
        return !!link.closest(selector);
      } catch (error) {
        return false;
      }
    });
  }

  function process(link) {
    if (!link || link.tagName !== "A") return;
    if (link.hasAttribute(CONFIG.processedAttribute)) return;
    if (!isWithinScope(link)) return;

    const href = link.getAttribute("href");
    if (!href || isSpecialLink(href)) return;

    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return;
    }

    if (!isCrossDomain(url.hostname)) return;
    if (normalizeHost(url.hostname) === normalizeHost(window.location.hostname))
      return;
    if (hasUTM(url)) return;

    url.searchParams.set("utm_source", CONFIG.utmSource);
    url.searchParams.set("utm_medium", detectMedium(link));
    url.searchParams.set("utm_campaign", CONFIG.utmCampaign);
    url.searchParams.set("utm_content", getUtmContent());
    url.searchParams.set("utm_term", getUtmTerm(link));

    link.href = url.toString();
    link.setAttribute(CONFIG.processedAttribute, "true");

    if (CONFIG.debug) {
      console.log("UTM applied:", url.toString());
    }
  }

  function getScopeRoots() {
    const roots = [];

    CONFIG.scopeSelectors.forEach(function (selector) {
      try {
        document.querySelectorAll(selector).forEach(function (node) {
          roots.push(node);
        });
      } catch (error) {}
    });

    return roots;
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll("a[href]").forEach(process);
  }

  let queued = false;
  let queuedNodes = new Set();

  function scheduleScan(node) {
    if (!node || node.nodeType !== 1) return;

    queuedNodes.add(node);

    if (queued) return;

    queued = true;

    requestAnimationFrame(function () {
      queuedNodes.forEach(function (queuedNode) {
        scan(queuedNode);
      });
      queuedNodes.clear();
      queued = false;
    });
  }

  function observe() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          if (node.matches && node.matches("a[href]")) {
            process(node);
          }

          if (node.querySelectorAll) {
            const matchingScope = CONFIG.scopeSelectors.find(
              function (selector) {
                try {
                  return node.matches(selector) || node.querySelector(selector);
                } catch (error) {
                  return false;
                }
              },
            );

            if (matchingScope) {
              scheduleScan(node);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    getScopeRoots().forEach(scan);
    observe();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// utm tagging end
